import { defineStore } from 'pinia'
import { refAutoReset } from '@vueuse/core'

import { type AlertType } from '@/view-models/common'

/**
 * 控制 layout 中的全域 alert的狀態
 */
export const useAlertStore = defineStore('alert', () => {
  const isAlertShown = refAutoReset(false, 5000)
  const alertText = ref('')
  const alertType = ref<AlertType>('success')

  function hideAlert() {
    isAlertShown.value = false
  }

  function showAlert({ message, type = 'success' }: { message: string; type?: AlertType }) {
    isAlertShown.value = true
    alertText.value = message
    alertType.value = type
  }

  function clearAlert() {
    alertText.value = ''
    alertType.value = 'success'
  }

  return { isAlertShown, alertText, alertType, hideAlert, showAlert, clearAlert }
})
